const InputtingUsersStyles = (theme) => ({
    inputtingUsers: {
        fontSize: '70%'
    }
})

export default InputtingUsersStyles